var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NIM"}},[_c('iframe',{ref:"NimIframe",attrs:{"src":_vm.src,"width":"100%","height":"100%","data-accid":"@buyer.WyAccId","frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b4f346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":["src","xlink:href"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact/nim.vue
// module id = is3T
// module chunks = 1